// removed by extract-text-webpack-plugin
module.exports = {"contentWrapper":"contentWrapper--2CM2u","content":"content--1M7lI contentWrapper--AHarZ"};


//////////////////
// WEBPACK FOOTER
// ./screens/Sessions/styles.css
// module id = 1026
// module chunks = 2